export class AOFReferralManager {
	constructor() {
		this.TARGET_DOMAINS = [ 'https://apply.aofund.org', 'https://apply.test.cloud.aofund.org' ];
		this.COOKIE_NAME = 'aof_referral_data';
		this.referral = typeof referral !== 'undefined' ? referral : null;
	}

	init() {
		this.storeReferralDataFromUrl();
		this.updateLinks();
	}

	// Parse current page URL and store referral info in cookie
	storeReferralDataFromUrl() {
		const urlParams = new URLSearchParams( window.location.search );
		const partnerID = urlParams.get( 'partner' );
		const campaignCode = urlParams.get( 'campaign' );

		if ( partnerID || campaignCode ) {
			const data = {};
			if ( partnerID ) data.partnerID = partnerID;
			if ( campaignCode ) data.campaignCode = campaignCode;

			const expires = new Date();
			expires.setTime( expires.getTime() + 30 * 24 * 60 * 60 * 1000 ); // 30 days
			const expiresStr = 'expires=' + expires.toUTCString();

			document.cookie = `${ this.COOKIE_NAME }=${ JSON.stringify( data ) }; ${ expiresStr }; path=/`;
		}
	}

	// Retrieve referral data from cookie
	getReferralDataFromCookie() {
		const cookies = document.cookie.split( ';' ).map( ( c ) => c.trim() );
		const match = cookies.find( ( c ) => c.startsWith( this.COOKIE_NAME + '=' ) );
		if ( ! match ) return null;

		try {
			return JSON.parse( match.split( '=' )[ 1 ] );
		} catch {
			return null;
		}
	}

	// Checks if the given href belongs to a target domain
	isTargetDomain( href ) {
		return this.TARGET_DOMAINS.some( ( domain ) => href.startsWith( domain ) );
	}

	// Check if a URL already contains a 'partner' param
	hasPartnerParam( href ) {
		try {
			const params = new URL( href ).searchParams;
			return params.has( 'partner' );
		} catch {
			return false;
		}
	}

	// Add query params to link
	appendParamsToLink( link, params ) {
		const url = new URL( link.href );
		for ( const key in params ) {
			if ( params[ key ] ) {
				url.searchParams.set( key, params[ key ] );
			}
		}
		link.href = url.toString();
	}

	// Main function to update qualifying links
	updateLinks() {
		const links = document.querySelectorAll( 'a[href]' );
		const referralData = this.getReferralDataFromCookie();

		links.forEach( ( link ) => {
			const href = link.getAttribute( 'href' );
			if ( ! this.isTargetDomain( href ) || this.hasPartnerParam( href ) ) return;

			// Use global referral variable if available
			if ( this.referral && this.referral.partner_id ) {
				this.appendParamsToLink( link, { partner: this.referral.partner_id } );
			}
			// Otherwise use cookie data
			else if ( referralData ) {
				this.appendParamsToLink( link, {
					partner: referralData.partnerID,
					campaign: referralData.campaignCode,
				} );
			}
		} );
	}
}

// Initialize after DOM is loaded
document.addEventListener( 'DOMContentLoaded', () => {
	const referralManager = new AOFReferralManager();
	referralManager.init();
} );
